import React from 'react';
import { connect } from 'react-redux'
import { Menu } from 'react-data-grid-addons'
import {
  duplicate_row,
  mark_read,
  publish_row,
  unpublish_row
} from '../actions'

const { ContextMenu, MenuItem } = Menu

const mapStateToProps = (state) => {
  return {
    rows: state.entry.items
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    duplicateRow: (feed_id, entry_id, rowIdx) => { dispatch( duplicate_row(feed_id, entry_id, rowIdx) ) },
    markRead:     (feed_id, entry_id, rowIdx) => { dispatch(     mark_read(feed_id, entry_id, rowIdx) ) },
    publishRow:   (feed_id, entry_id, rowIdx) => { dispatch(   publish_row(feed_id, entry_id, rowIdx) ) },
    unpublishRow: (feed_id, entry_id, rowIdx) => { dispatch( unpublish_row(feed_id, entry_id, rowIdx) ) }
  }
}

class ConnectedRowMenu extends React.Component {
  rowDuplicate = (e, data) => {
    const {feed_id, entry_id, rowIdx} = data
    this.props.duplicateRow(feed_id, entry_id, rowIdx)
  }

  rowPublish = (e, data) => {
    const {feed_id, entry_id, rowIdx} = data
    this.props.publishRow(feed_id, entry_id, rowIdx)
  }

  rowUnpublish = (e, data) => {
    const {feed_id, entry_id, rowIdx} = data
    this.props.unpublishRow(feed_id, entry_id, rowIdx)
  }

  markRead = (e, data) => {
    const {feed_id, entry_id, rowIdx} = data
    this.props.markRead(feed_id, entry_id, rowIdx)
  }


  render() {
    const {feed_id, rowIdx, id}=this.props;

    const row = this.props.rows[rowIdx]
    const entry_id = (row === undefined) ? 0 : row.id
    const published = (row === undefined) ? true : row.published
    const removed = ( row === undefined ) ? false : row.removed
    const newentry = (row === undefined) ? false : row.newentry

    let pubRow
    if ( removed ) {
      pubRow = ''
    } else if (published) {
      pubRow = (
        <MenuItem data={{ feed_id, entry_id, rowIdx }} onClick={ this.rowUnpublish }>
          <i className="material-icons c-red secondary-content">delete</i>Unpublish Row
        </MenuItem>
      )
    } else {
      pubRow = (
        <MenuItem data={{ feed_id, entry_id, rowIdx }} onClick={ this.rowPublish }>
          <i className="material-icons c-light-green secondary-content">publish</i>Publish Row
        </MenuItem>
      )
    }

    let newEntryIetm = ''
    if ( newentry ) {
      newEntryIetm = (
        <MenuItem data={{ feed_id, entry_id, rowIdx }} onClick={ this.markRead }>
          <i className="material-icons c-light-green secondary-content">mail_outline</i>Clear NewEntry flag
        </MenuItem>)
    }

    return (
      <ContextMenu id={id}  hideOnLeave={false}>
        <MenuItem data={{ feed_id, entry_id, rowIdx }} onClick={ this.rowDuplicate }><i className="material-icons c-light-green secondary-content">content_copy</i>Duplicate Row</MenuItem>
        { pubRow }
        { newEntryIetm }
      </ContextMenu>
    )
  }
}

const RowMenu = connect(mapStateToProps, mapDispatchToProps)(ConnectedRowMenu)
export default RowMenu



// WEBPACK FOOTER //
// ./src/js/components/RowMenu.js